import {TaskDashboardPage} from "./reports/taskDashboardPage";
import {UserDashboardPage} from "./reports/userDashboardPage";
import {BudgetDashboardPage} from "./reports/budgetDashboardPage";
import {RecordingValidationsPage} from "./reports/recordingValidationsPage";
import {TeamInsightsPage} from "./reports/teaminsights/teamInsightsPage";
import {DriveLogReportPage} from "./reports/driveLogReportPage";
import {DriveLogRecordingPage} from "./recording/driveLogRecordingPage";
import {MonthlyRecordingPage} from "./monthlyrecording/monthlyRecordingPage";
import {MyTimeAccountPage} from "./timeaccounts/myTimeAccountPage";
import {TimeAccountDashboardPage} from "./timeaccounts/timeAccountDashboardPage";
import {CurrentTimeAccountDashboardPage} from "./timeaccounts/currentTimeAccountDashboardPage";
import {CarsAdministrationPage} from "./admin/carsAdministrationPage";
import {GroupsAdministrationPage} from "./admin/groupsAdministrationPage";
import {DriveLogCategoriesAdministrationPage} from "./admin/driveLogCategoriesAdministrationPage";
import {BreakModelsAdministrationPage} from "./admin/breakModelsAdministrationPage";
import {TerminalsAdministrationPage} from "./admin/terminalsAdministrationPage";
import {UserSettingsPage} from "./user/userSettingsPage";
import {SettingsPage} from "./admin/settings/settingsPage";
import {UsersAdministrationPage} from "./admin/user/usersAdministrationPage";
import {MobileDevicesPage} from "./user/mobileDevicesPage";
import {Google, Jira, Microsoft, Slack} from "./admin/settings/panels";
import {TaskAdministrationPage} from "./admin/taskAdministrationPage";
import {AccountAdministrationPage} from "./admin/account/accountAdministrationPage";
import {DeleteAccountPage} from "./admin/account/deleteAccountPage";
import {PricingCustomizationPage} from "./admin/pricing/pricingCustomizationPage";
import {WorkScheduleModelsAdministrationPage} from "./admin/workScheduleModelsAdministrationPage";
import {OvertimeRulesAdministrationPage} from "./admin/overtimeRulesAdministrationPage";
import {WorkingTimeTypesAdministrationPage} from "./admin/workingTimeTypesAdministrationPage";
import {HolidaysAdministrationPage} from "./admin/holidaysAdministrationPage";
import {WorkingTimeRequestsReportPage} from "./requests/workingTimeRequestsReportPage";
import {WorkingTimeRequestsUserPage} from "./requests/workingTimeRequestsUserPage";
import {WorkingTimeRequestsApprovalPage} from "./requests/workingTimeRequestsApprovalPage";
import {ProjectTimeReportPage} from "./reports/projectTimeReportPage";
import {ProjectTimeRecordingPage} from "./recording/projectTimeRecordingPage";
import {WorkingTimeReportPage} from "./reports/workingTimeReportPage";
import {WorkingTimeRecordingPage} from "./recording/workingTimeRecordingPage";
import {SetupWizardPage} from "./setupWizardPage";
import {ResetPasswordPage} from "./auth/resetPasswordPage";
import {IdentifierForgottenPage} from "./auth/identifierForgottenPage";
import {RegisterPage} from "./auth/registerPage";
import {ReopenPage} from "./auth/reopenPage";
import {PasswordForgottenPage} from "./auth/passwordForgottenPage";
import {PaymentErrorPage} from "./payment/paymentErrorPage";
import {FinishInvitationSettingsPage} from "./invitation/finishInvitationSettingsPage";
import {PresenceBoardPage} from "./reports/presenceBoardPage";
import {TimelineReportPage} from "./timeline/timelineReportPage";
import {CombinedRecordingPage} from "./timeline/combinedRecordingPage";

// Make pages available globally for JSP initialization. These pages are entrypoints called from JSP files.

// Create global Pages namespace
declare global {
	interface Window {
		Pages: {
			// Recording
			WorkingTimeRecordingPage: typeof WorkingTimeRecordingPage;
			ProjectTimeRecordingPage: typeof ProjectTimeRecordingPage;
			DriveLogRecordingPage: typeof DriveLogRecordingPage;
			MonthlyRecordingPage: typeof MonthlyRecordingPage;
			// Reports
			WorkingTimeReportPage: typeof WorkingTimeReportPage;
			ProjectTimeReportPage: typeof ProjectTimeReportPage;
			UserDashboardPage: typeof UserDashboardPage;
			TaskDashboardPage: typeof TaskDashboardPage;
			BudgetDashboardPage: typeof BudgetDashboardPage;
			DriveLogReportPage: typeof DriveLogReportPage;
			RecordingValidationsPage: typeof RecordingValidationsPage;
			TeamInsightsPage: typeof TeamInsightsPage;
			MyTimeAccountPage: typeof MyTimeAccountPage;
			TimeAccountDashboardPage: typeof TimeAccountDashboardPage;
			CurrentTimeAccountDashboardPage: typeof CurrentTimeAccountDashboardPage;
			PresenceBoardPage: typeof PresenceBoardPage;
			// Requests
			WorkingTimeRequestsReportPage: typeof WorkingTimeRequestsReportPage;
			WorkingTimeRequestsUserPage: typeof WorkingTimeRequestsUserPage;
			WorkingTimeRequestsApprovalPage: typeof WorkingTimeRequestsApprovalPage;
			// Administration
			CarsAdministrationPage: typeof CarsAdministrationPage;
			GroupsAdministrationPage: typeof GroupsAdministrationPage;
			DriveLogCategoriesAdministrationPage: typeof DriveLogCategoriesAdministrationPage;
			BreakModelsAdministrationPage: typeof BreakModelsAdministrationPage;
			TerminalsAdministrationPage: typeof TerminalsAdministrationPage;
			UsersAdministrationPage: typeof UsersAdministrationPage;
			TaskAdministrationPage: typeof TaskAdministrationPage;
			UserSettingsPage: typeof UserSettingsPage;
			MobileDevicesPage: typeof MobileDevicesPage;
			SettingsPage: typeof SettingsPage;
			AccountAdministrationPage: typeof AccountAdministrationPage;
			DeleteAccountPage: typeof DeleteAccountPage;
			PricingCustomizationPage: typeof PricingCustomizationPage;
			WorkScheduleModelsAdministrationPage: typeof WorkScheduleModelsAdministrationPage;
			OvertimeRulesAdministrationPage: typeof OvertimeRulesAdministrationPage;
			WorkingTimeTypesAdministrationPage: typeof WorkingTimeTypesAdministrationPage;
			HolidaysAdministrationPage: typeof HolidaysAdministrationPage;
			SetupWizardPage: typeof SetupWizardPage;
			ResetPasswordPage: typeof ResetPasswordPage;
			IdentifierForgottenPage: typeof IdentifierForgottenPage;
			RegisterPage: typeof RegisterPage;
			ReopenPage: typeof ReopenPage;
			PasswordForgottenPage: typeof PasswordForgottenPage;
			// Payment
			PaymentErrorPage: typeof PaymentErrorPage;
			// Invitation
			FinishInvitationSettingsPage: typeof FinishInvitationSettingsPage;
			CombinedRecordingPage: typeof CombinedRecordingPage;
			TimelineReportPage: typeof TimelineReportPage;
		},
		// TODO: TIMR-11628 Consolidate global javascript contexts
		PageStatic: {
			Slack: typeof Slack;
			Jira: typeof Jira;
			Google: typeof Google;
			Microsoft: typeof Microsoft;
		}
	}
}

// Initialize global Pages namespace
if (typeof window !== 'undefined') {
	window.Pages = {
		// Recording
		WorkingTimeRecordingPage: WorkingTimeRecordingPage,
		ProjectTimeRecordingPage: ProjectTimeRecordingPage,
		DriveLogRecordingPage: DriveLogRecordingPage,
		MonthlyRecordingPage: MonthlyRecordingPage,
		// Reports
		WorkingTimeReportPage: WorkingTimeReportPage,
		ProjectTimeReportPage: ProjectTimeReportPage,
		UserDashboardPage: UserDashboardPage,
		TaskDashboardPage: TaskDashboardPage,
		BudgetDashboardPage: BudgetDashboardPage,
		DriveLogReportPage: DriveLogReportPage,
		RecordingValidationsPage: RecordingValidationsPage,
		TeamInsightsPage: TeamInsightsPage,
		MyTimeAccountPage: MyTimeAccountPage,
		TimeAccountDashboardPage: TimeAccountDashboardPage,
		CurrentTimeAccountDashboardPage: CurrentTimeAccountDashboardPage,
		PresenceBoardPage: PresenceBoardPage,
		// Requests
		WorkingTimeRequestsReportPage: WorkingTimeRequestsReportPage,
		WorkingTimeRequestsUserPage: WorkingTimeRequestsUserPage,
		WorkingTimeRequestsApprovalPage: WorkingTimeRequestsApprovalPage,
		// Administration
		CarsAdministrationPage: CarsAdministrationPage,
		GroupsAdministrationPage: GroupsAdministrationPage,
		DriveLogCategoriesAdministrationPage: DriveLogCategoriesAdministrationPage,
		BreakModelsAdministrationPage: BreakModelsAdministrationPage,
		TerminalsAdministrationPage: TerminalsAdministrationPage,
		UsersAdministrationPage: UsersAdministrationPage,
		TaskAdministrationPage: TaskAdministrationPage,
		UserSettingsPage: UserSettingsPage,
		MobileDevicesPage: MobileDevicesPage,
		SettingsPage: SettingsPage,
		AccountAdministrationPage: AccountAdministrationPage,
		DeleteAccountPage: DeleteAccountPage,
		PricingCustomizationPage: PricingCustomizationPage,
		WorkScheduleModelsAdministrationPage: WorkScheduleModelsAdministrationPage,
		OvertimeRulesAdministrationPage: OvertimeRulesAdministrationPage,
		WorkingTimeTypesAdministrationPage: WorkingTimeTypesAdministrationPage,
		HolidaysAdministrationPage: HolidaysAdministrationPage,
		SetupWizardPage: SetupWizardPage,
		ResetPasswordPage: ResetPasswordPage,
		IdentifierForgottenPage: IdentifierForgottenPage,
		RegisterPage: RegisterPage,
		ReopenPage: ReopenPage,
		PasswordForgottenPage: PasswordForgottenPage,
		// Payment
		PaymentErrorPage: PaymentErrorPage,
		// Invitation
		FinishInvitationSettingsPage: FinishInvitationSettingsPage,
		CombinedRecordingPage: CombinedRecordingPage,
		TimelineReportPage: TimelineReportPage
	};

	// Javascript in settings.jsp accesses these files directly which requires them to be available in the global context
	// TODO: TIMR-11628 Consolidate global javascript contexts
	window.PageStatic = {
		Slack: Slack,
		Jira: Jira,
		Google: Google,
		Microsoft: Microsoft
	}
}
